import { createService } from '@bonanza-social/toolkit/api';
import {
  ShopItemPurchaseResponseSchema,
  ShopItemsResponseSchema,
  ShopSalesResponseSchema,
  ShopSlotsResponseSchema,
  UserSettingsSchema,
} from './ShopService.schemas';

export default createService(
  {
    getItems: {
      method: 'GET',
      url: '/store/items',
      responseSchema: ShopItemsResponseSchema,
      headers: {
        'x-Feature-Purchase-Metagames': true,
      },
    },
    purchaseItem: {
      method: 'POST',
      url: ({ id }: { id: number }) => `/store/items/${id}`,
      responseSchema: ShopItemPurchaseResponseSchema,
    },
    getSales: {
      method: 'GET',
      url: '/store/sales',
      responseSchema: ShopSalesResponseSchema,
    },
    getSlots: {
      method: 'GET',
      url: '/store/slots',
      responseSchema: ShopSlotsResponseSchema,
    },
    purchaseSlot: {
      method: 'POST',
      url: ({ id }: { id: number }) => `/store/slots/${id}`,
      responseSchema: ShopItemPurchaseResponseSchema,
    },
    getUserSettings: {
      method: 'GET',
      url: '/settings',
      params: {
        coinsShopInfo: true,
      },
      responseSchema: UserSettingsSchema,
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
